import { Entity, SystemInterface, XYZ } from '@goodboydigital/odie';
import { Container, Renderer } from 'pixi.js';

import { Entity25D } from './Entity25D';
import { Scene25D } from './Scene25D';

export interface View25DSystemOptions
{
    stage?: Container;
}

export interface Camera25D extends XYZ
{
    zoom: number,
    fov: number,
    near: number,
    far: number,
}

export class View25DSystem implements SystemInterface<View25DSystemOptions>
{
    public static DEFAULT_NAME = 'view25d';

    public w: number;
    public h: number;
    public scene!: Scene25D;
    public camera: Camera25D;
    public readonly stage: Container;
    public entities: Entity25D[];
    public perspective = 0.35;
    public container: Container;
    public zoomContainer: Container;
    public entitiesContainer: Container;

    constructor(_entity: Entity, opts: View25DSystemOptions = {})
    {
        this.w = -1;
        this.h = -1;

        this.stage = opts.stage || new Container();
        this.entities = [];

        this.container = new Container();
        this.stage.addChild(this.container);

        this.zoomContainer = new Container();
        this.container.addChild(this.zoomContainer);

        this.entitiesContainer = new Container();
        this.entitiesContainer.sortableChildren = true;
        this.zoomContainer.addChild(this.entitiesContainer);
        
        this.camera = {
            x: 0, y: 0, z: 0,
            zoom: 1,
            near: 1,
            far: 100,
            fov: 60 * (Math.PI / 180),
        };

        this.resize(1, 1);

        // override the render function...
        const render = this.stage.render.bind(this.stage);

        this.stage.render = (renderer: Renderer) =>
        {
            this.scene.renderStart();

            render(renderer);

            this.scene.renderFinish();
        };
    }

    public render(): void
    {
        const scale = this.camera.z + this.camera.zoom;

        this.zoomContainer.scale.set(scale);
    }

    public entityAddedToScene(ent: Entity): void
    {
        const entity = ent as Entity25D;

        if (entity.view25d)
        {
            const view = entity.view25d.view;

            this.entitiesContainer.addChild(view);
            if (!this.entities.includes(entity)) this.entities.push(entity);
        }
    }

    public entityRemovedFromScene(ent: Entity): void
    {
        const entity = ent as Entity25D;

        if (entity.view25d)
        {
            const view = entity.view25d.view;

            if (view.parent === this.entitiesContainer) this.entitiesContainer.removeChild(view);
            if (this.entities.includes(entity)) this.entities.splice(this.entities.indexOf(entity), 1);
        }
    }

    public empty(): void
    {
        let i = this.entities.length;

        while (i--) this.scene.removeFromScene(this.entities[i]);

        this.entitiesContainer.removeChildren();
    }

    public resize(w: number, h: number): void
    {
        if (this.w === w && this.h === h) return;

        this.w = w;
        this.h = h;
        this.stage.x = this.w / 2;
        this.stage.y = this.h / 2;
    }
}
